<template>
    <div class="business-content-main tutorial-main">
        <div class="tutorial-content">
            <div class="tutorial-menu">
                <div class="menu-box">
                    <div class="menu-header">
                        <span>快速导航</span>
                    </div>
                    <div class="menu-divider" style="margin-bottom: 15px"></div>
                    <div :key="index" v-for="(item, index) in menuList" class="menu-items">
                        <div :class="{ active: index == isActive }" @click="onCateClick(item.Id, index)">
                            <i v-if="index == isActive" class="el-icon-caret-right" style="color: #909399"></i>
                            <span>{{ item.Name }}</span>
                        </div>
                        <div class="menu-divider"></div>
                    </div>
                </div>
            </div>
            <div class="tutorial-list">
                <div v-if="!isSelected">
                    <div class="tutorial-quest-box">
                        <div class="tutorial-quest">
                            <el-input @keyup.enter.native="searchQuest" v-model="searchData.key" placeholder="请输入你要搜索的关键词" clearable></el-input>
                            <el-button class="btn-primary" @click="searchQuest">
                                <i class="el-icon-search">搜索</i>
                            </el-button>
                        </div>
                    </div>
                    <div class="quest-list" v-for="(item, index) in tutorialList" :key="index">
                        <div class="quest-list-item" @click="onQuestClick(item)">
                            <span>{{ item.Title }}</span>
                        </div>
                        <div class="menu-divider"></div>
                    </div>
                    <div class="pagination" v-if="newsCount > 0">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="searchData.page"
                            :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                            :page-size="searchData.limit"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="newsCount"
                        ></el-pagination>
                    </div>
                </div>
                <div v-else class="detail-box">
                    <div class="detail-header">
                        <div class="detail-tips">
                            <span> <i class="el-icon-right" style="color: #8c98cc"></i>帮助详情 </span>
                        </div>
                        <div class="returnBack">
                            <el-button size="mini" class="returnBackBtn" @click="returnBack">返回列表</el-button>
                        </div>
                    </div>
                    <div class="detail-divider"></div>
                    <div class="detail-title">{{ onSelectedItem.Title }}</div>
                    <div class="detail-date">{{ onSelectedItem.PublishTime }}</div>
                    <div class="detail-content" v-html="onSelectedItem.Contents"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {},
    data() {
        return {
            onSelectedItem: {},
            isSelected: false,
            isActive: 0,
            searchData: {
                CateId: '',
                App: ',BPc,',
                page: 1,
                limit: 15,
                key: ''
            },
            newsCount: 0,
            keyWord: '',
            menuList: [],
            tutorialList: [
                // {
                //   App: ",OfficialWebsite,",
                //   Author: "超级管理员",
                //   CateId: "82667898-0093-4ec0-954e-62b79c4cf6c6",
                //   Contents:
                //     "<p><img src='http://publicfiles.chehuijia.com.cn/UploadFile/EditorImg/Public/Images/8e2ecbc9e4d24c6cafc759e3c26c3235.png' style='max-width:100%;'><br></p>",
                //   FirstImage: "",
                //   Id: "0e517e50-6e28-4b1d-a7b7-4c93fc5b5c8a",
                //   IsHot: "False",
                //   IsTop: "False",
                //   PublishTime: "2020-06-09 18:57:28",
                //   ReadPermission: "0",
                //   Soure: "",
                //   Summary: "",
                //   Title: "车管家注册流程"
                // }
            ],
            menuItemClass: ''
        };
    },
    created() {
        this.getNewsCategories();
    },
    mounted() {},
    watch: {},
    methods: {
        //'/api/NewsCategory/GetNewsCategories'
        getNewsCategories() {
            this.$util
                .axiosGet({
                    url: '/api/News/GetNewsCategories',
                    data: {
                        App: ',BPc',
                        IsHot: true
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.menuList = res.data;
                        this.searchData.CateId = this.menuList[0].Id;
                        this.getNewsList();
                    }
                })
                .catch(() => {});
        },
        getNewsList() {
            this.$util
                .axiosGet({
                    url: '/api/News/GetNewsList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.tutorialList = res.data;
                        this.newsCount = res.count;
                    }
                })
                .catch(() => {});
        },
        returnBack() {
            this.isSelected = false;

            this.getNewsList();
        },
        onCateClick(id, index) {
            this.menuItemClass = 'font-weight:bold;padding-left:5px;';
            this.isActive = index;
            this.searchData.CateId = id;
            this.searchData.page = 1;
            this.searchData.key = '';
            this.getNewsList();
            this.isSelected = false;
        },
        onQuestClick(item) {
            this.onSelectedItem = item;
            this.isSelected = true;
            // this.$util.setLocalStorage("newsDetail", item);
            // this.$router.push({
            //   path: "/tutorial/detail"
            // });
        },
        searchQuest() {
            this.searchData.CateId = '';
            if (this.searchData.key == '') {
                this.$message({
                    message: '关键词不能为空',
                    type: 'warn'
                });
                return;
            }
            this.isSelected = false;
            this.getNewsList();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getNewsList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getNewsList();
        }
    }
};
</script>
<style lang="less" scoped>
.tutorial-main {
    margin: 0 auto;
    height: 100%;
    overflow: auto;
}
.tutorial-content {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 100px;
    display: flex;
}
.tutorial-menu {
    width: 300px;
}
.menu-box {
    width: 300px;
    height: 600px;
    background: url('../../assets/images/leftnav_bg.jpg');
    border-radius: 15px;
    // border: 1px solid #dcdfe6;
    padding: 20px;
}
.menu-divider {
    width: 100%;
    border-bottom: 1px dashed #dcdfe6;
}
.menu-header {
    border-left: 5px solid #ffbb01;
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 10px;
    padding-left: 10px;
}
.menu-items {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    flex-direction: column;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
    margin-bottom: 15px;
    :hover {
        font-weight: bold;
    }
}
.tutorial-list {
    width: 100%;
    margin-left: 15px;
    position: relative;
}
.tutorial-quest-box {
    border-radius: 10px;
    padding: 30px 30px 30px 30px;
    margin-bottom: 25px;
    background: #d2eeff;
}
.tutorial-quest {
    display: flex;
}
.quest-list {
    :hover {
        transform: translate(5px);
        transition: all 0.2s ease;
    }
}
.quest-list-item {
    cursor: pointer;
    padding: 10px;
    span {
        margin: 10px;
        font-size: 18px;
    }
}
.pagination {
    height: 33px;
    position: absolute;
    text-align: center;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: 0 auto;
    margin-bottom: -40px;
}
.active {
    font-weight: 800;
    i {
        transform: translateX(250px);
        -webkit-transform: translateX(250px); /*兼容-webkit-引擎浏览器*/
        -moz-transform: translateX(250px); /*兼容-moz-引擎浏览器*/
    }
}
.detail-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 0px 10px 0px;
}
.detail-tips {
    font-size: 22px;
    font-weight: bold;
}
.returnBack {
    right: 0px;
}
.returnBackBtn {
    border: 1px solid #ddd;
    border-radius: 20px;
}
.detail-divider {
    border-bottom: 1px solid #dcdfe6;
}
.detail-box {
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
}
.detail-title {
    font-size: 30px;
    font-weight: 800;
    text-align: left;
    margin-bottom: 20px;
    margin-top: 20px;
}
.detail-date {
    margin-bottom: 20px;
}
</style>
